/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:checkUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/17 | 富士通株式会社        | 新規作成
//================================================================================
 */
/*
 * 文字数チェック
 * @param {String} str 対象の文字列
 * @param {Number} limit 最大文字数
 * @return {Boolean} true：最大文字数以下／false：最大文字数オーバー
 */
export function co_checkLength(str, limit) {

	if ( co_stringToArray(str).length <= limit ) {
		return true;
	}
	return false;
}

/*
 * 桁数一致チェック
 * @param {String} str 対象文字列
 * @param {Number} maxLength 最大桁数
 * @return {Boolean} true：文字数が一致 / false：文字数が不一致
 */
export function co_checkDigitEqualed( str, maxLength ) {

	if( str != null ) {
		if ( co_stringToArray( str ).length == maxLength ) {
			return true;
		}
	}

	return false;

}

/*
 * 文字列をサロゲート文字の配列(Array)に変換
 * @param {String} str 対象の文字列
 * @return {Object} 変換後の文字配列
 */
function co_stringToArray (str) {
    return str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g) || [];
}

/*
 * 文字列(String)、または、配列(Array)の空チェック
 * undefined、null、長さ0の文字列、配列を空と判断します
 * ※Boolean、Number、Symbol、Object、Date、Functionなどで使用してはいけません
 * @param {String | Array} val 対象の文字列、または、配列
 * @return {Boolean} true：空／false：空ではない
 */
export function co_isEmpty( val ) {

	if ( val === undefined || val === null || val.length === 0 ) {
		return true;
	}
	return false;
}

/*
 * 半角数字チェック
 * @param {String} str 対象の文字列
 * @return {Boolean} true：文字列が半角数字のみ／false：文字列が半角数字のみではない
 */
export function co_checkHalfNumber( str ) {

	if ( str.match(/^[0-9]+$/) ) {
		return true;
	}
	return false;
}

